// @flow
import React from 'react';
import './RecaptchaDisclaimer.css';

type Props = {
  className?: string,
};

const RecaptchaDisclaimer = ({ className = '' }: Props) => (
  <p className={`recaptcha-disclaimer ${className}`}>
    Este site é protegido pelo reCAPTCHA e se aplicam a{' '}
    <a
      href="https://policies.google.com/privacy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Política de Privacidade
    </a>{' '}
    e os{' '}
    <a
      href="https://policies.google.com/terms"
      target="_blank"
      rel="noopener noreferrer"
    >
      Termos de Serviço
    </a>{' '}
    do Google.
  </p>
);

export default RecaptchaDisclaimer;
